import { Modal, useModals } from 'almanac-ui/Modal'
import { RootProps } from './Types'
import Styles from './Root.module.scss'
import cx from 'classnames'
import { useInterruptBrowserBack } from '../useInterruptBrowserBack'
import { ResponsiveDesign } from 'screens/blaze/Home/components/ResponsiveDesign'
import { useFlipperFlag } from 'hooks/useFlipperFlag'
import { WizardTourPortal } from '../WizardTour/WizardTourPortal'
import { WizardTour } from '../WizardTour/WizardTour'
import { BottomButtons } from 'components/DocRightRailV2/BottomButtons/BottomButtons'
import { ConfirmCloseModal } from '../ConfirmCloseModal/ConfirmCloseModal'
import { useCallback } from 'react'

const Root = ({ children, bodyClassName, 'aria-labelledby': ariaLabelledBy, onClose, type }: RootProps) => {
  const { closeModal, openModal, closeAllModals } = useModals()
  useInterruptBrowserBack()
  const isWizardTourEnabled = useFlipperFlag('wizards_tour')

  const handleClose = useCallback(() => {
    onClose?.()
    closeModal()
  }, [onClose, closeModal])

  const handleCloseAllModals = useCallback(() => {
    onClose?.()
    closeAllModals()
  }, [onClose, closeAllModals])

  return (
    <>
      <Modal.Root
        size="fullscreen"
        bodyClassName={cx(Styles.root, bodyClassName)}
        aria-labelledby={ariaLabelledBy}
        onClose={handleClose}
      >
        <ResponsiveDesign.Desktop>
          <div
            className={Styles.wizardUnderlay}
            data-testid="wizard-underlay"
            onClick={() => {
              openModal(
                ConfirmCloseModal,
                { onCancel: closeModal, onConfirm: handleCloseAllModals, onPressOutside: handleClose },
                { newStack: true },
              )
            }}
          />
        </ResponsiveDesign.Desktop>
        <div className={Styles.content}>{children}</div>
      </Modal.Root>
      {isWizardTourEnabled && type && (
        <WizardTourPortal>
          <WizardTour type={type} />
          <BottomButtons videoTutorialType={type} />
        </WizardTourPortal>
      )}
    </>
  )
}

export { Root }
